import type { IconType } from 'react-icons';
import { LuClock, LuCloudMoon, LuMoon, LuMoonStar, LuSun, LuSunrise, LuSunset } from 'react-icons/lu';

export const THEME_KEYS = ['pre-dawn', 'morning', 'day', 'evening', 'late-evening', 'night'] as const;
export type ThemeKey = (typeof THEME_KEYS)[number];

export interface ThemeState {
  auto: boolean;
  manual: ThemeKey | null;
}

export const THEME_LABELS: Record<ThemeKey, string> = {
  'pre-dawn': 'Pre-Dawn',
  morning: 'Morning',
  day: 'Day',
  evening: 'Evening',
  'late-evening': 'Late-Evening',
  night: 'Night',
};

export const THEME_ICONS: Record<ThemeKey, IconType> = {
  'pre-dawn': LuMoon,
  morning: LuSunrise,
  day: LuSun,
  evening: LuSunset,
  'late-evening': LuCloudMoon,
  night: LuMoonStar,
};

export const AUTO_ICON: IconType = LuClock;

export function isThemeKey(value: unknown): value is ThemeKey {
  return typeof value === 'string' && (THEME_KEYS as readonly string[]).includes(value);
}
